import { useState } from "react";
import ToolbarButton from "./toolbar-button";
import AlertModal from "@/components/common/modals/alert-modal";

const HtmlSave = ({ onSave }: { onSave: () => void })=> {
  const [saveConfirmOpen, setSaveConfirmOpen] = useState(false);

  const openSave = () => setSaveConfirmOpen(true);
  const closeSave = () => setSaveConfirmOpen(false);

  const handleConfirmSave = () => {
    onSave();
    closeSave();
  };

  return (
    <>
      <ToolbarButton
        className="flex w-fit items-center gap-x-1"
        onClick={openSave}
      >

        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.333 3.333H12.5L16.667 7.5V16.667C16.667 17.109 16.4914 17.5329 16.1788 17.8455C15.8663 18.158 15.4424 18.3336 15 18.3336H5C4.55797 18.3336 4.13405 18.158 3.82148 17.8455C3.50892 17.5329 3.33333 17.109 3.33333 16.667V3.333Z"
            stroke="#273646"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Save
      </ToolbarButton>

      <AlertModal
        isOpen={saveConfirmOpen}
        isLoading={false}
        onClose={closeSave}
        onConfirm={handleConfirmSave}
      />
    </>
  );
};

export default HtmlSave;


